import {authHeader} from '../backend'
import {handleResponse} from './handleResponse'

export const commonService = {
  getCourseListByCcode
}

function getCourseListByCcode (ccode) {
  let requestOptions = {
    method: 'GET',
    cache: 'no-cache',
    headers: authHeader()
  }

  return fetch(`${process.env.BASE_API}/common/club/course/list/${ccode}?` + Date.now(), requestOptions).then(handleResponse)
}



// WEBPACK FOOTER //
// ./src/router/commonRouter.js